<style scoped  lang="less">
  @import 'detailsOdds.less'; // 引入公共LESS文件
</style>
<template>
  <div>
    <div class="data-loading" style="padding:20vh 0 50vh 0;"  v-if="isloginShow">
          <van-loading vertical><span class="loadtext">{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</span></van-loading>
    </div>
    <div v-if="company&&luckList&&!isloginShow"> 
      <!-- oddsBox -->
      <div class="oddsBox">
        <div class="listType">
              <a href="javascript:void(0);" :class="tableLIShow==1?'on':''"  @click="tableLITab(1)">{{ langConfig.details[langConfig.curLang]['ODDS']['1x2'] }}</a> 
              <a href="javascript:void(0);" :class="tableLIShow==2?'on':''"  @click="tableLITab(2)">{{ langConfig.details[langConfig.curLang]['ODDS']['ASIAN'] }}</a> 
              <a href="javascript:void(0);" :class="tableLIShow==3?'on':''"  @click="tableLITab(3)">{{ langConfig.details[langConfig.curLang]['ODDS']['OVER_UNDER'] }}</a> 
        </div>
        <!-- <a href="javascript:void(0);" @click="aaa">数据</a>  -->
        <table :class="`tabli_${tableLIShow}`">
          <thead>
            <tr>
              <th>Bookmakers</th>
              <th> </th>
              <th class="td_sort1">1</th>
              <th class="td_sort1">x</th>
              <th class="td_sort1">2</th>
              <th colspan="2" class="td_sort2">{{ langConfig.details[langConfig.curLang]['ODDS']['ASIAN'] }}</th>
              <!-- <th></th> -->
              <th class="td_sort3">{{ langConfig.details[langConfig.curLang]['ODDS']['GOALS'] }}</th>
              <th class="td_sort3">{{ langConfig.details[langConfig.curLang]['ODDS']['OVER'] }}</th>
              <th class="td_sort3">{{ langConfig.details[langConfig.curLang]['ODDS']['UNDER'] }}</th>
              <th class="td_sort_a"></th>
            </tr>
          </thead>
          <tbody>
            <!-- asian threeWay total -->
            <template v-for="(item, index) in company">
              <template v-if="trShow(item)">
                <tr :key="index">
                  <td rowspan="2" class="td_1">
                    {{item.name}}
                    <img src="~@/assets/images/details/event/9.svg"  v-if="item.hasLive==1" />
                  </td>
                  <td>{{ langConfig.details[langConfig.curLang]['ODDS']['INITIAL_ODDS'] }}</td>
                  <td class="td_sort1"><span>{{getThreeWay(item,'homeInit')}}</span></td>
                  <td class="td_sort1"><span>{{getThreeWay(item,'drawInit')}}</span></td>
                  <td class="td_sort1"><span>{{getThreeWay(item,'awayInit')}}</span></td>
                  <td class="td_sort2">
                    <span class="blue w_m60 w_m_tr">
                      {{(getTd('asian',item,'handInit')=='-'?'':(getTd('asian',item,'handInit'))+'  ' )}}
                    </span>
                    <span class="w_m60 w_m_tl">
                      {{getOddsWay(getTd('asian',item,'homeInit'))}}
                    </span>
                  </td> 
                  <td class="td_sort2">
                    <span class="blue w_m60 w_m_tr">
                      {{(getTd('asian',item,'handInit')=='-'?'': (getTd('asian',item,'handInit')*-1)+'  ' )}}
                    </span>
                    <span class="w_m60 w_m_tl">
                      {{getOddsWay(getTd('asian',item,'awayInit'))}}
                    </span>
                  </td>
                  <td class="td_sort3">
                    <span :class="getTd('total',item,'totalInit')!='-'?'blue':''">
                          {{getTd('total',item,'totalInit')}}
                    </span>
                  </td>
                  <td class="td_sort3"><span>{{getOddsWay(getTd('total',item,'overInit'))}}</span></td>
                  <td class="td_sort3"><span>{{getOddsWay(getTd('total',item,'underInit'))}}</span></td>
                  <td rowspan="2"  class="td_sort_a"><a href="javascript:void(0);" class="toMore" @click="historyShow(item)"></a></td>
                </tr>
                <!-- tr_r -->
                <tr :key="index+'r'">
                  <td>{{ langConfig.details[langConfig.curLang]['ODDS']['LIVE_ODDS'] }}</td>
                  <td class="td_sort1"><span :class="getClass('threeWay',item,'home')">{{getThreeWay(item,'home')}}</span></td>
                  <td class="td_sort1"><span :class="getClass('threeWay',item,'draw')">{{getThreeWay(item,'draw')}}</span></td>
                  <td class="td_sort1"><span :class="getClass('threeWay',item,'away')">{{getThreeWay(item,'away')}}</span></td>
                  <td class="td_sort2">
                    <span class="blue w_m60 w_m_tr">
                      {{(getTd('asian',item,'hand')=='-'?'':(getTd('asian',item,'hand'))+'  ' )}}
                    </span>
                    <span class="w_m60 w_m_tl" :class="getClass('asian',item,'home')">{{getOddsWay(getTd('asian',item,'home'))}}</span>
                  </td> 
                  <td class="td_sort2">
                    <span class="blue w_m60 w_m_tr">
                      {{(getTd('asian',item,'hand')=='-'?'': (getTd('asian',item,'hand')*-1)+'  ' )}}
                    </span>
                    <span class="w_m60 w_m_tl"  :class="getClass('asian',item,'away')">{{getOddsWay(getTd('asian',item,'away'))}}</span>
                  </td>
                  <td class="td_sort3">
                    <span :class="getTd('total',item,'total')!='-'?'blue':''">
                          {{getTd('total',item,'total')}}
                    </span>
                  </td>
                  <td class="td_sort3"><span  :class="getClass('total',item,'over')">{{getOddsWay(getTd('total',item,'over'))}}</span></td>
                  <td class="td_sort3"><span  :class="getClass('total',item,'under')">{{getOddsWay(getTd('total',item,'under'))}}</span></td>
                </tr>
              </template>



              <tr :key="index+'r'" v-if="false">
                <td>{{ langConfig.details[langConfig.curLang]['ODDS']['LIVE_ODDS'] }}</td>
                <td class="td_sort1"><span :class="getThreeWayClass(item,'homeInit','home')">{{getThreeWay(item,'home')}}</span></td>
                <td class="td_sort1"><span :class="getThreeWayClass(item,'drawInit','draw')">{{getThreeWay(item,'draw')}}</span></td>
                <td class="td_sort1"><span :class="getThreeWayClass(item,'awayInit','away')">{{getThreeWay(item,'away')}}</span></td>
                <td class="td_sort2">
                  <span class="blue w_m60 w_m_tr">
                    {{(getTd('asian',item,'hand')=='-'?'':(getTd('asian',item,'hand'))+'  ' )}}
                  </span>
                  <span class="w_m60 w_m_tl" :class="isScoreNum(getTd('asian',item,'homeInit'),getTd('asian',item,'home'))">{{getOddsWay(getTd('asian',item,'home'))}}</span>
                </td> 
                <td class="td_sort2">
                  <span class="blue w_m60 w_m_tr">
                    {{(getTd('asian',item,'hand')=='-'?'': (getTd('asian',item,'hand')*-1)+'  ' )}}
                  </span>
                  <span class="w_m60 w_m_tl"  :class="isScoreNum(getTd('asian',item,'awayInit'),getTd('asian',item,'away'))">{{getOddsWay(getTd('asian',item,'away'))}}</span>
                </td>
                <td class="td_sort3">
                  <span :class="getTd('total',item,'total')!='-'?'blue':''">
                        {{getTd('total',item,'total')}}
                  </span>
                </td>
                <td class="td_sort3"><span>{{getOddsWay(getTd('total',item,'over'))}}</span></td>
                <td class="td_sort3"><span>{{getOddsWay(getTd('total',item,'under'))}}</span></td>
              </tr>
            </template>
            <!-- <tr>
              <td>Initial Odds</td>
              <td><span>4.50</span></td>
              <td><span>4.50</span></td>
              <td><span>4.50</span></td>
              <td><span>+0.5/1  </span><span>2.05</span></td> 
              <td><span>+0.5/1  </span><span>2.05</span></td>
              <td><span>4.50</span></td>
              <td><span>4.50</span></td>
              <td><span>4.50</span></td>
            </tr> -->
            <!-- <tr>
              <td rowspan="2">
                S2
                <img src="~@/assets/images/details/event/9.svg" />
              </td>
              <td>Initial Odds</td>
              <td><span>4.50</span></td>
              <td><span class="red">4.50</span></td>
              <td><span>4.50</span></td>
              <td><span class="blue">+0.5/1  </span><span>2.05</span></td> 
              <td><span>+0.5/1  </span><span>2.05</span></td>
              <td><span class="green">4.50</span></td>
              <td><span>4.50</span></td>
              <td><span>4.50</span></td>
              <td rowspan="2"><a href="javascript:void(0);" class="toMore" @click="historyShow()"></a></td>
            </tr> -->
          </tbody>
        </table>
      </div>
      <!-- 弹窗 -->
      <div class="pupHistory" v-if="false">
        <div class="oddsHistory">
          <a href="javascript:void(0);"  class="oddClose" @click="historyHide();"></a>
          <p class="ph_t">
            History of Odds Change
          </p>
          <div class="ph_tab">
            <a href="javascript:void(0);" class="on">1x2</a>
            <a href="javascript:void(0);" class="">Asian Handicap</a>
            <a href="javascript:void(0);" class="">Over/Under</a> 
          </div>
          <div class="ph_data">
            <div class="ph_side">
              <a href="javascript:void(0);" class="on">
                1x2<img src="~@/assets/images/details/event/9.svg" />
              </a>
              <a href="javascript:void(0);" class="">
                1x2<img src="~@/assets/images/details/event/9.svg" />
              </a>
              <a href="javascript:void(0);" class="">
                1x2<img src="~@/assets/images/details/event/9.svg" />
              </a>
              <a href="javascript:void(0);" class="">
                1x2<img src="~@/assets/images/details/event/9.svg" />
              </a>
              <a href="javascript:void(0);" class="">
                1x2<img src="~@/assets/images/details/event/9.svg" />
              </a>
            </div>
            <div class="ph_table">
              <div class="t_th">
                <span>Time</span>
                <span>1</span>
                <span>x</span>
                <span>2</span>
                <span>Home Win Rate</span>
                <span>Draw Rate</span>
                <span>Away Win Rate</span>
                <span>Return</span>
                <span></span>
              </div>
              <ul>
                <li>
                  <span>27/08 21:21</span>
                  <span>2.23</span>
                  <span>3.64</span>
                  <span>3.05</span>
                  <span>65.4%</span>
                  <span>3.6%</span>
                  <span>31%</span>
                  <span>95.8%</span>
                  <span>Push</span>
                </li>
                <li>
                  <span>27/08 21:21</span>
                  <span>2.23</span>
                  <span>3.64</span>
                  <span>3.05</span>
                  <span>65.4%</span>
                  <span>3.6%</span>
                  <span>31%</span>
                  <span>95.8%</span>
                  <span>Push</span>
                </li>
                <li>
                  <span>27/08 21:21</span>
                  <span>2.23</span>
                  <span>3.64</span>
                  <span>3.05</span>
                  <span>65.4%</span>
                  <span>3.6%</span>
                  <span>31%</span>
                  <span>95.8%</span>
                  <span>Push</span>
                </li>
                <li>
                  <span>27/08 21:21</span>
                  <span>2.23</span>
                  <span>3.64</span>
                  <span>3.05</span>
                  <span>65.4%</span>
                  <span>3.6%</span>
                  <span>31%</span>
                  <span>95.8%</span>
                  <span>Push</span>
                </li>
                <li>
                  <span>27/08 21:21</span>
                  <span>2.23</span>
                  <span>3.64</span>
                  <span>3.05</span>
                  <span>65.4%</span>
                  <span>3.6%</span>
                  <span>31%</span>
                  <span>95.8%</span>
                  <span>Push</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- center bottom-->
      <van-popup class="popupOdds" v-model="pupHistoryShow" :position="!isWeb?'center':'bottom'" round  get-container="#app" >
        <div class="oddsHistory">
          <a href="javascript:void(0);"  class="oddClose" @click="historyHide();"></a>
          <p class="ph_t">
            {{ langConfig.details[langConfig.curLang]['ODDS']['HISTORY_CHANGE'] }}
          </p>
          <div class="ph_tab">
            
              <!-- 数据类型 1=亚指 2=欧指 3=大小 -->
            <a href="javascript:void(0);" :class="pupLogData.type==2?'on':''" @click="logTab(2)">{{ langConfig.details[langConfig.curLang]['ODDS']['1x2'] }}</a>
            <a href="javascript:void(0);" :class="pupLogData.type==1?'on':''" @click="logTab(1)">{{ langConfig.details[langConfig.curLang]['ODDS']['ASIAN'] }}</a>
            <a href="javascript:void(0);" :class="pupLogData.type==3?'on':''" @click="logTab(3)">{{ langConfig.details[langConfig.curLang]['ODDS']['OVER_UNDER'] }}</a>
            <div class="pht_switch" v-if="pupLogData.type==2">
              <span>{{ langConfig.details[langConfig.curLang]['ODDS']['WIN_RATE'] }}</span>
              <el-switch
                class="a_switch"
                v-model="pupLogData.winRatr"
                >
              </el-switch>
            </div>
          </div>
          <div class="ph_data">
          
              <div class="ph_side" :class="pupLogData.type==2&&pupLogData.winRatr?'ph_side_r':''">
                <div class="ph_sideBox">
                  <template v-for="(item, index) in company">
                    <a href="javascript:void(0);"  :class="pupLogData.companyIndex==index?'on':''"  :key="index" @click="logTabCompany(index)">
                      {{item.name}}
                      <img src="~@/assets/images/details/event/9.svg" v-if="item.hasLive==1" />
                    </a>
                  </template>

                </div>
                
                <!-- <a href="javascript:void(0);" class="">
                  1x2<img src="~@/assets/images/details/event/9.svg" />
                </a> -->
              </div>
              <div class="ph_table" :class="'ph_table_'+pupLogData.type" v-if="pupLogData.type==2">
                <div class="t_th">
                  <span class="th_s1" :class="pupLogData.winRatr?'th_s1_Ratr':''">{{ langConfig.details[langConfig.curLang]['ODDS']['TIME'] }}</span>
                  <span class="th_s2" v-if="!isWeb||(isWeb&&!pupLogData.winRatr)">1</span>
                  <span class="th_s3" v-if="!isWeb||(isWeb&&!pupLogData.winRatr)">x</span>
                  <span class="th_s4" v-if="!isWeb||(isWeb&&!pupLogData.winRatr)">2</span>
                  <span class="th_s5" v-if="!isWeb||(isWeb&&pupLogData.winRatr)">{{ langConfig.details[langConfig.curLang]['ODDS']['HOME_WIN_RATE'] }}</span>
                  <span class="th_s6" v-if="!isWeb||(isWeb&&pupLogData.winRatr)">{{ langConfig.details[langConfig.curLang]['ODDS']['DRAW_RATE'] }}</span>
                  <span class="th_s7" v-if="!isWeb||(isWeb&&pupLogData.winRatr)">{{ langConfig.details[langConfig.curLang]['ODDS']['AWAY_WIN_RATE'] }}</span>
                  <span class="th_s8" v-if="!isWeb||(isWeb&&pupLogData.winRatr)">{{ langConfig.details[langConfig.curLang]['ODDS']['RETURN'] }}</span>
                  <span class="th_s9"></span>
                </div> 
                <ul>
                  <template v-if="luckRecords.length>0">
                    <li v-for="(item, index) in luckRecords" :key="index">
                      <span class="th_s1" :class="pupLogData.winRatr?'th_s1_Ratr':''">{{dataTimeRe(item.updateTime)}}</span>
                      <span class="th_s2" :class="
                      getLogClass( luckRecords[(index*1+1)>(luckRecords.length*1-1)?(luckRecords.length*1-1):(index*1+1)].recordValues[0],item.recordValues[0] ) " v-if="!isWeb||(isWeb&&!pupLogData.winRatr)">{{getpupThreeWay(item.recordValues[0])}}</span>
                      <span class="th_s3" :class="getLogClass(luckRecords[(index*1+1)>(luckRecords.length*1-1)?(luckRecords.length*1-1):(index*1+1)].recordValues[2],item.recordValues[2])" v-if="!isWeb||(isWeb&&!pupLogData.winRatr)">{{getpupThreeWay(item.recordValues[2])}}</span>
                      <span  class="th_s4" :class="getLogClass(luckRecords[(index*1+1)>(luckRecords.length*1-1)?(luckRecords.length*1-1):(index*1+1)].recordValues[1],item.recordValues[1])" v-if="!isWeb||(isWeb&&!pupLogData.winRatr)">{{getpupThreeWay(item.recordValues[1])}}</span>
                      <span class="th_s5" v-if="!isWeb||(isWeb&&pupLogData.winRatr)">{{item.ratios[0]}}</span>
                      <span class="th_s6" v-if="!isWeb||(isWeb&&pupLogData.winRatr)">{{item.ratios[2]}}</span>
                      <span class="th_s7" v-if="!isWeb||(isWeb&&pupLogData.winRatr)">{{item.ratios[1]}}</span>
                      <span class="th_s8" v-if="!isWeb||(isWeb&&pupLogData.winRatr)">{{item.ratios[3]}}</span>
                      <span class="th_s9" :class="pupLogData.winRatr?'th_s9_Ratr':''">{{recordType[item.recordType]}}</span>
                    </li>
                  </template>
                  <div class="no-data no-data_odds" v-else>
                      <img :src="require(`@/assets/images/icon-nodata.png`)" alt="" />
                      <span>{{ langConfig.txtLang[langConfig.curLang]['NO_DATA'] }}</span>
                  </div>
                </ul>
              </div>
              <div class="ph_table" :class="'ph_table_'+pupLogData.type" v-if="pupLogData.type==1">
                <div class="t_th">
                  <span class="th_s1">{{ langConfig.details[langConfig.curLang]['ODDS']['TIME'] }}</span>
                  <span class="th_s2">{{ langConfig.details[langConfig.curLang]['ODDS']['HOME'] }}</span>
                  <span class="th_s3">{{ langConfig.details[langConfig.curLang]['ODDS']['HANDICAP'] }}</span>
                  <span class="th_s4">{{ langConfig.details[langConfig.curLang]['ODDS']['AWAY'] }}</span>
                  <span class="th_s5"></span>
                </div>
                <ul>
                  <template v-if="luckRecords.length>0">
                    <li v-for="(item, index) in luckRecords" :key="index">
                      <span class="th_s1">{{dataTimeRe(item.updateTime)}}</span>
                      <span class="th_s2" :class="getLogClass(luckRecords[(index*1+1)>(luckRecords.length*1-1)?(luckRecords.length*1-1):(index*1+1)].recordValues[0],item.recordValues[0])">{{getpupThreeWay(common.addValue(item.recordValues[0],1))}}</span>
                      <span  class="th_s3" :class="getLogClass(luckRecords[(index*1+1)>(luckRecords.length*1-1)?(luckRecords.length*1-1):(index*1+1)].recordValues[2],item.recordValues[2])">{{item.recordValues[2]}}</span>
                      <span  class="th_s4" :class="getLogClass(luckRecords[(index*1+1)>(luckRecords.length*1-1)?(luckRecords.length*1-1):(index*1+1)].recordValues[1],item.recordValues[1])">{{getpupThreeWay(common.addValue(item.recordValues[1],1))}}</span>
                      <span class="th_s5">{{recordType[item.recordType]}}</span>
                    </li>
                  </template>
                  <div class="no-data no-data_odds" v-else>
                      <img :src="require(`@/assets/images/icon-nodata.png`)" alt="" />
                      <span>{{ langConfig.txtLang[langConfig.curLang]['NO_DATA'] }}</span>
                  </div>
                </ul>
              </div>
              <div class="ph_table" :class="'ph_table_'+pupLogData.type" v-if="pupLogData.type==3">
                <div class="t_th">
                  <span class="th_s1">{{ langConfig.details[langConfig.curLang]['ODDS']['TIME'] }}</span>
                  <span class="th_s2">{{ langConfig.details[langConfig.curLang]['ODDS']['TOTAL'] }}</span>
                  <span class="th_s3">{{ langConfig.details[langConfig.curLang]['ODDS']['OVER'] }}</span>
                  <span class="th_s4">{{ langConfig.details[langConfig.curLang]['ODDS']['UNDER'] }}</span>
                  <span class="th_s5"></span>
                </div>
                <ul>
                  <template v-if="luckRecords.length>0">
                    <li v-for="(item, index) in luckRecords" :key="index">
                      <span  class="th_s1">{{ dataTimeRe(item.updateTime) }}</span>
                      <span  class="th_s2" :class="getLogClass(luckRecords[(index*1+1)>(luckRecords.length*1-1)?(luckRecords.length*1-1):(index*1+1)].recordValues[2],item.recordValues[2])">{{item.recordValues[2]}}</span>
                      <span  class="th_s3" :class="getLogClass(luckRecords[(index*1+1)>(luckRecords.length*1-1)?(luckRecords.length*1-1):(index*1+1)].recordValues[0],item.recordValues[0])">{{getpupThreeWay(common.addValue(item.recordValues[0],1))}}</span>
                      <span  class="th_s4" :class="getLogClass(luckRecords[(index*1+1)>(luckRecords.length*1-1)?(luckRecords.length*1-1):(index*1+1)].recordValues[1],item.recordValues[1])">{{getpupThreeWay(common.addValue(item.recordValues[1],1))}}</span>
                      <span  class="th_s5">{{recordType[item.recordType]}}</span>
                    </li>
                  </template>
                  <div class="no-data no-data_odds" v-else>
                      <img :src="require(`@/assets/images/icon-nodata.png`)" alt="" />
                      <span>{{ langConfig.txtLang[langConfig.curLang]['NO_DATA'] }}</span>
                  </div>
                </ul>
              </div>
          </div>
        </div>
      </van-popup>

      
    </div>
  </div>
</template>

<script>
import { getMatchLuckList,getMatchLuckCompany,getMatchLuckLog } from '@/api/api';
export default {
  components: {
      
  },
  data() { 
    return {
      isReadTime:0,
      isloginShow:true,
       baseParam:{ 
          userToken: '',
      },
      pupHistoryShow:false,
      tableLIShow:1,
      luckList:null,
      company:[],
      oddsFormRadio:1,
      luckList_old:null,
      luckList_stay:null,
      oddsRenewal:{
        timer:0,
        isStay:false,//是否停留
      },
      isHistoryShow:true,
      pupLogData:{
        companyIndex:0,
        type:2,
      },
      luckRecords:[],
      screenWidth:2000,
  
      isWeb:false,
      recordType:{
        1:this.langConfig.details[this.langConfig.curLang]['ODDS']['INITIAL'],//初
        2:this.langConfig.details[this.langConfig.curLang]['ODDS']['LIVE'],//即
        3:this.langConfig.details[this.langConfig.curLang]['ODDS']['PUSH']//走
        //Win  Push  Lose
      },
      value1:true,
      LogItem:null,//历史选择存储
    };
  },
  methods: { 
    trShow(item){
      var _this=this;
      let tableLIShow=JSON.parse(JSON.stringify(_this.tableLIShow))
      let isWeb=JSON.parse(JSON.stringify(_this.isWeb));
      let three_homeInit=_this.getThreeWay(item,'home')=='-'?true:false;
      let three_drawInit=_this.getThreeWay(item,'draw')=='-'?true:false;
      let three_awayInit=_this.getThreeWay(item,'away')=='-'?true:false;
      let asian_home=_this.getOddsWay(_this.getTd('asian',item,'home'))=='-'?true:false;
      let asian_away=_this.getOddsWay(_this.getTd('asian',item,'away'))=='-'?true:false;
      let total_over=_this.getOddsWay(_this.getTd('total',item,'over'))=='-'?true:false;
      let total_under=_this.getOddsWay(_this.getTd('total',item,'under'))=='-'?true:false;
      //console.log('111111',three_homeInit,three_drawInit,three_awayInit,asian_home,asian_away,total_over,total_under);
      //console.log('tableLIShow',tableLIShow,isWeb);
      if(three_homeInit&&three_drawInit&&three_awayInit&&asian_home&&asian_away&&total_over&&total_under){
        return false;
      }else if(isWeb){
        if(tableLIShow==1&&(three_homeInit&&three_drawInit&&three_awayInit)){
          return false;
        }else if(tableLIShow==2&&(asian_home&&asian_away)){
          return false;
        }else if(tableLIShow==3&&(total_over&&total_under)){
          return false;
        }
      }
      return true;
      

    },
    logdingFlag(){
      if(typeof(window) != 'undefined' && this.isloginShow){
        return true;
      }
      return false;
    },
    oddsToggle(val){
        // oddsRenewal:{
        //   timer:0,
        //   isStay:false,//是否停留
        // },
        
        var _this=this;
        var luckList=JSON.parse(JSON.stringify(this.luckList));
        var luckList_old=JSON.parse(JSON.stringify(this.luckList_old));
        var luckList_stay=JSON.parse(JSON.stringify(this.luckList_stay));
        var oddsRenewal=JSON.parse(JSON.stringify(this.oddsRenewal));
        if(val.asian.length==0&&val.threeWay.length==0&&val.total.length==0){
          return;
        }
        if(luckList==null){
          return;
        }
        if(luckList_stay==null){
          luckList_stay=JSON.parse(JSON.stringify(luckList));
        }
        function addData(key){
          if(val[key].length==0){return;};
          for (let i = 0; i < val[key].length; i++) {
            let data_i=val[key][i];
            let companyId=data_i.companyId
            if(typeof luckList_stay[key]!='undefined'){
              let index = luckList_stay[key].findIndex(item => item.companyId === companyId);
              //console.log('index',index)
              if(index>-1){
                let luckData_i=JSON.parse(JSON.stringify(luckList_stay[key][index]));
                let newLuckData_i = _this.common.mergeObjects(luckData_i,data_i);
                luckList_stay[key][index]=newLuckData_i;
              }
            }
          }
        }
        addData('asian');
        addData('threeWay');
        addData('total');

        if(!oddsRenewal.isStay){
          oddsRenewal.isStay=true;
        }else{
          clearTimeout(oddsRenewal.timer);
        }
        function recover(){
            var oddsRenewal=JSON.parse(JSON.stringify(_this.oddsRenewal));
            oddsRenewal.isStay=false;
            _this.oddsRenewal=oddsRenewal;
            //console.log('缓动恢复',oddsRenewal);
            // _this.luckList_old=JSON.parse(JSON.stringify(luckList));
            _this.luckList=JSON.parse(JSON.stringify(luckList_stay));
        }
        oddsRenewal.timer=setTimeout(function() {
            recover();
        }, 200);
        this.oddsRenewal=oddsRenewal;
        this.luckList_stay=luckList_stay;
    },
    getClass(luck,item,name){
      var _this=this;
      var newData=_this.getTd(luck,item,name,-1);
      var oldData=_this.getTd(luck,item,name,'old');
      var vlass='';
      if(newData=='-'||oldData=='-'){
        return '';
      }
      if(!(newData&&newData>=0)||!(oldData&&oldData>=0)){
        return '';
      }
      if(newData>oldData){
        return 'green';
      }
      if(newData<oldData){
        return 'red';
      }
    },
    aaa(){
      //console.log('luckList_old',this.luckList_old);
      //console.log('luckList_stay',this.luckList_stay);
      //console.log('luckList',this.luckList);
      //console.log('oddsRenewal',this.oddsRenewal);
    },
    tableLITab(val){
      this.tableLIShow=val;
    },
    getLogClass(a,b){
      if(a==b){
        return '';
      }
      if(a==0&&b==0){
        return '';
      }
      if(a==null||b==null){
        return '';
      }
      var val=this.isScoreNum(a,b);
      if(val){
        return 'green';
      }else{
        return 'red';
      }
    },
    logTab(type){
      let pupLogData=JSON.parse(JSON.stringify(this.pupLogData));
      //console.log('typetypetype',type,this.company);
      let logTabObj={
        2:1,
        1:2,
        3:3
      }
      pupLogData.type=type;
      this.pupLogData=pupLogData;
      // this.tableLIShow=pupLogData;
      //console.log('pupLogData',pupLogData);
      this.getMatchLuckLogData();
    },
    logTabCompany(index){
      let pupLogData=JSON.parse(JSON.stringify(this.pupLogData));
      //console.log('indexindexindex',index);
      pupLogData.companyIndex=index;
      this.pupLogData=pupLogData;
      this.getMatchLuckLogData();
    },
    //比大小
    isScoreNum(a,b){
      if(a=='-'||b=='-'){
        return '';
      }
      if(!a||!b){
        return '';
      }
      if (b !== 0 && a !== 0) {
        if (b > a) {
          return true;
        } else if (b < a) {
          return false;
        }
      }
      return '';
    },
    //获取指数内容 OddsRadio
    getOddsFormRadio(){
      var _this=this;
      if(typeof window!='undefined'){
        var setting=_this.common.getCookie('setting');  
        var oddsFormRadio=1;
        if(setting!=null&&setting!=undefined&&setting){
          setting=JSON.parse(setting);
          if(typeof setting.oddsFormRadio!='undefined'){
            oddsFormRadio=setting.oddsFormRadio*1;
          }
        }
        this.oddsFormRadio=oddsFormRadio;
      }
    },
    //指数输出
    getOddsWay(val){
      var _this=this;
      var oddsFormRadio=JSON.parse(JSON.stringify(this.oddsFormRadio));
      //console.log('val',val,'|||',_this.common.oddsFromChange(val, oddsFormRadio));
      if(val=='-'){
        return '-';
      }if(!val){
        return '-';
      }else{
        val=_this.common.addValue(val*1,1);
        return _this.common.oddsFromChange(val, oddsFormRadio);
      }
    },
    //澳指输出
    getThreeWay(item,name){
      var _this=this;
      var val= _this.getTd('threeWay',item,name);
      var oddsFormRadio=JSON.parse(JSON.stringify(this.oddsFormRadio));
      //console.log('val',val,'|||',_this.common.oddsFromChange(val, oddsFormRadio));
      if(val=='-'){
        return '-';
      }if(!val){
        return '-';
      }else{
        return _this.common.oddsFromChange(val, oddsFormRadio);
      }
    },
    //澳指输出-弹窗
    getpupThreeWay(num){
      var _this=this;
      var val= num;
      var oddsFormRadio=JSON.parse(JSON.stringify(this.oddsFormRadio));
      
      if(!val){
        return '-';
      }else{
        return _this.common.oddsFromChange(val, oddsFormRadio);
      }
    },
    //澳指大小Class
    getThreeWayClass(item,valInit,val){
      var _this=this;
      var data=_this.isScoreNum(_this.getThreeWay(item,valInit),_this.getThreeWay(item,val));
      if(_this.getThreeWay(item,valInit)=='-'||_this.getThreeWay(item,val)=='-'){
        return '';
      }
      if(data){
        return 'green';
      }else{

        return 'red';
      }
    },
    getTd(luck,item,name,type){
      // {{getTd('threeWay',item,'homeInit')}}
      var _this=this; 
      if(type=='old'&&this.luckList_old==null){
        return '-'
      }
      let luckList=JSON.parse(JSON.stringify((type=='old'?this.luckList_old:this.luckList)));
      //console.log('luckListlengthlengthlength',luckList[luck]);
      //console.log('luck',luck,'item',item,'name',name);
      if(luckList[luck]==undefined){
        return '-'
      }
      var itemData=luckList[luck].find(obj => obj.companyId*1 === item.id*1);
      //console.log('vvv'+item.id,itemData==undefined,itemData);
      if(itemData&&itemData!=undefined){
        return itemData[name];
      }else{
        return '-'
      }
      getTd('asian',item,'hand')
    },
    dataCleaning(val,obj){
      val.forEach((d, i) => {
          //console.log('d',d,'i',i)
      });
      return obj;
    },

    dataTimeRe(val){
      var _dateForm = 'dd/MM HH:mm';

      if(this.langConfig.curLang == 'kr'){
        _dateForm = 'MM-dd HH:mm';
      }

      var _time=this.common.dateStr(val,_dateForm);
      return _time;
    },

    //数据读取
    async getMatchLuckListData(){
        let obj={
          matchId:this.matchId,
        }
        var _this=this;
        let param = Object.assign(obj, this.baseParam);
        //console.log('getMatchLuckList_param',param);
        await getMatchLuckList(param).then((res) => {
          this.isloginShow=false;
          //console.log('getMatchLuckList_res',res);
          let data=JSON.parse(JSON.stringify(res.data));
          //console.log('getMatchLuckList_data',data);
          let luckList={};
          // _this.dataCleaning(data.asian,luckList);
          this.luckList=data;
          this.luckList_old=data;
          this.getOddsFormRadio();
         // _this.luckList=(data.eventList||[]).slice().reverse();
        }).catch((res) => {
          console.error(res)
        })
    },
    //日志读取
    async getMatchLuckLogData(){
        let LogItem=JSON.parse(JSON.stringify(this.LogItem)); 
        //console.log('LogItem',LogItem);
        let pupLogData=JSON.parse(JSON.stringify(this.pupLogData));  
        let company=JSON.parse(JSON.stringify(this.company));
        let obj={
          matchId:this.matchId,
          type:pupLogData.type,
          companyId:company[pupLogData.companyIndex].id
        }
        var _this=this;
        let param = Object.assign(obj, this.baseParam);
        //console.log('getMatchLuckLog_param',param);
        await getMatchLuckLog(param).then((res) => {
          //console.log('getMatchLuckLog_res',res);
          let data=JSON.parse(JSON.stringify(res.data));
          //console.log('getMatchLuckLog_data',data);
          // _this.dataCleaning(data.asian,luckList);
          // this.luckList=data;
          this.luckRecords=data.luckRecords||[];
          this.pupHistoryShow=true;
          this.getOddsFormRadio();
         // _this.luckList=(data.eventList||[]).slice().reverse();
        }).catch((res) => {
          this.luckRecords=[];
          console.error(res)
        })
    },
    //公司列表
    async getMatchLuckCompany(){
        let obj={
          matchId:this.matchId,
        }
        var _this=this;
        let param = Object.assign(obj, this.baseParam);
        //console.log('getMatchLuckCompany_param',param);
        await getMatchLuckCompany(param).then((res) => {
          //console.log('getMatchLuckCompany_res',res);
          let data=JSON.parse(JSON.stringify(res.data));
          //console.log('getMatchLuckCompany_data',data);
         _this.company=data.companies||[];
         // _this.luckList=(data.eventList||[]).slice().reverse();
        }).catch((res) => {
          console.error(res)
        })
    },
    init(){ 
      if(!this.matchId){
        return;
      } 
    
      this.getMatchLuckListData();
      this.getMatchLuckCompany();
    },
    historyShow(item){
      var company=JSON.parse(JSON.stringify(this.company));
      var companyIndex=company.findIndex(item1 => item1.id ==item.id);
      var pupLogData=JSON.parse(JSON.stringify(this.pupLogData));
      var tableLIShow=JSON.parse(JSON.stringify(this.tableLIShow));
      //console.log('tableLIShow',tableLIShow);
      // companyIndex.companyIndex=pupLogData.type; //tableLIShow
      //tableLIShow
      var companyObj={
        1:2,
        2:1,
        3:3
      }
      pupLogData.type=companyObj[tableLIShow];
      pupLogData.companyIndex=companyIndex;
      // pupLogData.companyIndex=companyObj[pupLogData.type];
      this.pupLogData=pupLogData;
      //console.log('pupLogData',pupLogData);
      // this.pupLogData={
      //   companyIndex:companyIndex,
      //   type:2,
      //   winRatr:false,
      //   companyId:item.id
      // }
      // this.tableLIShow=1;
      this.LogItem=item;
      this.luckRecords=[];
      this.getMatchLuckLogData();
    },
    historyHide(){
      this.pupHistoryShow=false;
    },
    
    //获取屏幕宽度
    handleResize() {
      if(typeof window!='undefined'){
        this.isWeb=(window.innerWidth<767?true:false)
        this.screenWidth = window.innerWidth;
        // this.viewportHeight = window.innerHeight;
        
      }
    },
  },
  created() {
    this.isReadTime=this.isRead;
    this.handleResize();
    this.getOddsFormRadio();
    //this.getOddsFormRadio();

    this.init();
  },
  watch: {
    isRead(val){
      if(val!=this.isReadTime){
        this.init();
        this.isReadTime=val;

        console.log('ODDS-数据重置');
      }
    },
    OddsRadio(val){
      this.getOddsFormRadio();
    },
    socketLuckList(val){
      // 指数odds统计-字符串4637003 {"matchId":"4637003","asian":[{"companyId":"3000181","hand":"-0.75","home":"1.05","away":"0.75"},{"companyId":"3000390","hand":"-0.75","home":"1.06","away":"0.76"},{"companyId":"3000048","hand":"-0.5","home":"0.78","away":"0.95"},{"companyId":"3000379","hand":"-0.5","home":"0.99","away":"0.81"},{"companyId":"3000471","hand":"-0.5","home":"0.97","away":"0.83"},{"companyId":"3000368","hand":"-0.5","home":"0.98","away":"0.82"},{"companyId":"3001000","hand":"-0.5","home":"0.98","away":"0.8"}],"threeWay":[{"companyId":"3000068","home":"1","draw":"67","away":"151"},{"companyId":"3000181","home":"1","draw":"51","away":"81"},{"companyId":"3000390","home":"1","draw":"51","away":"81"}],"total":[{"companyId":"3000068","total":"2.5","over":"0.53","under":"1.37"},{"companyId":"3000181","total":"2.75","over":"0.8","under":"1"},{"companyId":"3000390","total":"2.75","over":"0.81","under":"1.01"},{"companyId":"3000379","total":"2.75","over":"0.95","under":"0.85"},{"companyId":"3000471","total":"2.75","over":"0.93","under":"0.87"},{"companyId":"3001000","total":"2.75","over":"0.93","under":"0.85"}]}
      var _this=this;
      this.oddsToggle(val)
      //console.log('socketLuckList',val);
   


    }
  },
  mounted() {
    if(typeof window!='undefined'){
      window.addEventListener('resize', this.handleResize);
    }
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
  props: {
    OddsRadio: {
      type: Number,
      default:0
    },
    socketLuckList: {
      type: Object,
      default:null
    }, 
    match: {
      type: Object,
      default:null
    }, 
    matchId: {
      type: Number,
      default:null
    },
    socketEventList:{
      type:Array,
      default:() =>[],
    },
    isRead: {
      type: Number,
      default: 0,
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsOdds.vue